import { prepareHeaderDate } from '../../../shared/helpers/filters/prepareHeaderDate';
import { DateDistribution } from '../../../shared/models/context-insights/ContextInsightsResponse';
import { PeriodType } from '../../../shared/types/prompt/PeriodType';
import { TFunction } from 'i18next';

export const createSentimentChartMatrix = (
  periodType: PeriodType,
  dateDistribution: DateDistribution[],
  t: TFunction
): (string | number)[][] => {
  if (!dateDistribution || dateDistribution.length === 0) {
    return [['date', t('positive'), t('neutral'), t('negative')]];
  }

  const headers = ['date', t('positive'), t('neutral'), t('negative')];

  const rows = dateDistribution.map((item) => {
    const total = item.total > 0 ? item.total : 1;
    return [
      prepareHeaderDate(item.date, periodType),
      Math.round((item.sentiment.POSITIVE / total) * 100),
      Math.round((item.sentiment.NEUTRAL / total) * 100),
      Math.round((item.sentiment.NEGATIVE / total) * 100),
    ];
  });

  return [headers, ...rows];
};
